window.addEventListener('load', function(event) {
  const thumbsGallery = new Swiper('.tabbed-content__tab-titles', {
    wrapperClass: 'tabbed-content__tab-titles-track',
    slideClass: 'tabbed-content__tab-title',
    speed: 500,
    slidesPerView: 'auto',
    slideToClickedSlide: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
        //slidesPerView: 'auto'
      },
      // when window width is >= 920px 
      768: {
        //slidesPerView: 2,
      },
      1024: {
        //slidesPerView: 4,
      }
    }
  });

  const tabGallery = new Swiper('.tabbed-content__tab-gallery', {
    wrapperClass: 'tabbed-content__tab-track',
    slideClass: 'tabbed-content__tab-item',
    speed: 500,
    autoHeight: true,
    thumbs: {
      autoScrollOffset: 2,
      swiper: thumbsGallery
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        //slidesPerView: 'auto'
      },
      // when window width is >= 920px 
      768: {
        //slidesPerView: 2,
      },
      1024: {
        //slidesPerView: 4,
      }
    }
  });
}, false);